import { Row, Col, Checkbox } from "antd";
import "./ProposalSetup.less";
import { RootStateOrAny, useSelector } from "react-redux";

type Props = {
  checkedSurfaces: any;
  handleSurfaceChange: any;
  checkedProjectDefaultsSurfaces: any;
  handleProjectDefaultsSurfaceChange: any;
};

const SurfaceCheckboxes = (props: Props) => {
  const { surface } = useSelector(
    (state: RootStateOrAny) => state.proposalDefaults
  );
  const checkValue = (item: any) => {
    const found = props.checkedSurfaces?.find(
      (obj: any) => obj._id === item._id
    );
    return found ? true : false;
  };

  const projectDefaultsCheck = (item: any) => {
    if (item.checked) return true;
    else return false
  }
  return (
    <div className="surface-ch-container">
      <h1>Surface Preparation</h1>
      <div className="s-ch-sub">
        <Row>
          {surface.map((item: any) => {
            return (
              <Col span={23} key={item._id}>
                <Checkbox
                  checked={checkValue(item)}
                  onChange={(e) => props.handleSurfaceChange(e, item)}
                >
                  <p>
                    <strong>{item.title}:</strong>
                    {item.detail}
                  </p>
                </Checkbox>
              </Col>
            );
          })}
          {props.checkedProjectDefaultsSurfaces.map((item: any) => {
            return (
              <Col span={23} key={item._id}>
                <Checkbox
                  checked={projectDefaultsCheck(item)}
                  onChange={(e) => props.handleProjectDefaultsSurfaceChange(e, item, "Surface")}
                >
                  <p>
                    <strong>{item.title}:</strong>
                    {item.detail}
                  </p>
                </Checkbox>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default SurfaceCheckboxes;
